﻿import {isNullOrEmpty} from "@2d-front-monorepo/core";
import {JSX, ReactNode, useCallback} from "react";
import {Link} from "react-router";
import {ButtonKind} from "../ButtonKind";
import buttonTypeClass from "../helpers/buttonTypeClass";

export type BackButtonProps = {
	children?: ReactNode;
	kind?: ButtonKind;
	small?: boolean;
	href?: string;
};

export default function BackButton({children, kind, small, href, ...rest}: BackButtonProps): JSX.Element {
	const className = buttonTypeClass(kind) + (small ? " form__button--small" : "");

	const handleGoBack = useCallback(function (e: React.MouseEvent<HTMLAnchorElement>){
		e.preventDefault()
		if (window.history.length > 1) {
			window.history.back();
		} else {
			window.history.replaceState(null, "", "/");
		}
	}, []);

	return isNullOrEmpty(href) ?
		<a href="#" onClick={handleGoBack} className={className} {...rest}>{children}</a> :
		<Link to={href} className={className} {...rest}>{children}</Link>;
}
